import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// A BrowserRouter keeps the window's scroll position across a route change, so
// following a link from halfway down one page lands halfway down the next one.
// Rendered inside the router, this resets it. Back and forward (POP) keep their
// position, as does a link to an anchor on the target page.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP' || hash) {
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, hash, navigationType]);

  return null;
};

export default ScrollToTop;
